import { headers } from '@/_services/headers'
import { encrypt, decrypt } from '../../_services/encryption';
const state = {
    airtimeBillers: [],
    paymentBillers: [],
    dstvAdons: [],
};
const mutations = {
    // set airtime billers
    SET_AIRTIME_BILLERS(state, payload) {
        state.airtimeBillers = payload;
    },
    // set payment billers
    SET_PAYMENT_BILLERS(state, payload) {
        state.paymentBillers = payload;
    },
    SET_DSTV_ADONS(state, payload) {
        state.dstvAdons = payload;
    },
};
const actions = {
    // get airtime billers
    async getAirtimeBillers({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
            if (accessToken) {
                headers.Authorization = 'Bearer ' + accessToken;
                const response = await this._vm.$http.get(`/Bills/AirtimeBillers`, { headers });
                const decryptedData = decrypt(response.data);
                const userParseData = JSON.parse(decryptedData);
                if (response.status === 200) {
                    commit('SET_AIRTIME_BILLERS', userParseData);
                } 
            }
    },
    // purchase airtime 
    async purchaseAirtime({}, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Bills/AirtimePurchase`, encryptedData, { headers });
            return response;
        }
    },
    // get payment billers
    async getPaymentBillers({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Bills/PaymentBillers?categoryId=data`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_PAYMENT_BILLERS', userParseData);
            } 
        }
    },
    // get payment billers for disco
    async getPaymentBillersForDisco({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Bills/PaymentBillers?categoryId=Disco`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_PAYMENT_BILLERS', userParseData);
            }
        }
    },
    // get payment billers for Tv
    async getPaymentBillersForTv({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Bills/PaymentBillers?categoryId=Tv`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_PAYMENT_BILLERS', userParseData);
            }
        }
    },
    // purchase payment
    async dataBillsPayment({}, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Bills/BillsPayment`, encryptedData, { headers });
            return response;
        }
    },
    // action for bundle lookup
    async bundleLookup({}, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Bills/BundleLookUp`, encryptedData, { headers });
            return response;
        }
    },
    // action for bills payment
    async billsPayment({}, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Bills/BillsPayment`, encryptedData, { headers });
            return response;
        }
    },
    // get dstv addons
    async getDstvAdons({ commit }, data) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Bills/DstvAdons?biller=DSTV&paymentItem=${data}`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_DSTV_ADONS', userParseData);
            }
        }
    },
};
const getters = {
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};